"use strict";

// video-slide web component
if (!customElements.get("video-slide")) {
  customElements.define(
    "video-slide",
    class VideoSlide extends HTMLElement {
      constructor() {
        super();
        this.videoEl = this.querySelector("video");
        this.playIcon = this.querySelector("[data-play-icon]");
        this.closeIcon = this.querySelector("[data-close-icon]");
        this.videoEl.controls = false;
      }

      connectedCallback() {
        this.videoEl.play();
        this.playIcon.addEventListener("click", this.playVideo);
        this.closeIcon.addEventListener("click", this.closeVideo);
        this.videoEl.addEventListener("ended", this.closeVideo);
      }

      playVideo = () => {
        document
          .querySelectorAll('video-slide[data-playing-status="true"]')
          .forEach((videoSlideEl) => videoSlideEl.closeVideo());

        this.setAttribute("data-playing-status", true);
        this.videoEl.muted = false;
        this.videoEl.loop = false;
        this.videoEl.volume = 1;
        this.videoEl.currentTime = 0;
        // this.videoEl.controls = true;
        this.videoEl.play();
      };

      closeVideo = () => {
        this.setAttribute("data-playing-status", false);
        this.videoEl.muted = true;
        this.videoEl.loop = true;
        this.videoEl.volume = 0;
        // this.videoEl.controls = false;
        this.videoEl.play();
      };
    },
  );
}

if (!customElements.get("swiper-slider")) {
  customElements.define(
    "swiper-slider",
    class SwiperComponent extends HTMLElement {
      constructor() {
        super();
        this.container = this.querySelector("[data-slider-container]");
      }

      async connectedCallback() {
        const module = await import(flu.chunks.swiper);
        const Swiper = module.default || module.Swiper || window.Swiper;
        new Swiper(this.container, {
          loop: false,
          slidesPerView: "auto",
          spaceBetween: 16,
          freeMode: true,
        });
      }
    },
  );
}

// Bacth details
if (!customElements.get("batch-details")) {
  customElements.define(
    "batch-details",
    class BatchDetails extends HTMLElement {
      constructor() {
        super();
        this.searchFormEl = this.querySelector("[data-search-form]"); // search form where search input is
        this.searchInputEl = this.querySelector("[data-search-input]"); // badge id search input
        this.contentBoxEl = this.querySelector("[data-search-results]"); // content box to render search results
        this.searchErrorEl = this.querySelector("[data-search-error]"); // error element
        this.serverErrorEl = this.querySelector("[data-search-server-error]"); // server error element
        this.convertSchemaToHtml = window.convertSchemaToHtml || null;
      }

      async connectedCallback() {
        // assign convertSchemaToHtml
        if (!window.convertSchemaToHtml) {
          const { convertSchemaToHtml } = await import(
            flu.chunks.shopifyRichTextRenderer
          );
          this.convertSchemaToHtml = convertSchemaToHtml;
          window.convertSchemaToHtml = convertSchemaToHtml;
        }

        if (this.searchFormEl && this.searchInputEl) {
          this.init();
        } else {
          console.error("Search form or input not found for batch details");
        }
      }

      async fetchBatchMetaobject(handle) {
        const shopifyDomain = Shopify.shop;
        const storefrontAccessToken = "7eee1d2459823c709db23dce18eb9cfe";
        const returnData = {
          detailsHtml: "",
          shopifyServerError: false,
          notFound: false,
        };

        const query = `#graphql
            query GetMetaobject {
              metaobject(handle: {type: "batch_info", handle: "${handle}"}) {
                field(key: "batch_info") {
                  value
                }
              }
            }
          `;

        try {
          const response = await fetch(
            `https://${shopifyDomain}/api/2025-04/graphql.json`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
              },
              body: JSON.stringify({ query }),
            },
          );

          const result = await response.json();

          // Handle GraphQL errors
          if (result.errors) {
            console.error("GraphQL Errors:", result.errors);
            return { ...returnData, shopifyServerError: true };
          }

          // Handle missing data
          if (!result.data || !result.data.metaobject) {
            console.warn("Metaobject not found or not accessible.");
            return { ...returnData, notFound: true };
          }

          // Success
          const detailsValue = result.data.metaobject.field.value;
          const detailsHtml = this.convertSchemaToHtml(
            JSON.parse(detailsValue),
            { newLineToBreak: true },
          );
          return { ...returnData, detailsHtml };
        } catch (err) {
          // Handle network or unexpected errors
          console.error("Fetch Error:", err);
          return { ...returnData, shopifyServerError: true };
        }
      }

      init() {
        this.searchFormEl.addEventListener("submit", (e) => {
          e.preventDefault();
          this.handleSubmit();
        });
      }

      async handleSubmit() {
        // add loading
        this.classList.add("loading");

        // fetch
        const { detailsHtml, shopifyServerError, notFound } =
          await this.fetchBatchMetaobject(this.searchInputEl.value);

        if (detailsHtml) {
          this.contentBoxEl.innerHTML = detailsHtml;
          this.contentBoxEl.classList.remove("hidden");
          this.contentBoxEl.classList.add("loaded");

          // hide others
          this.searchErrorEl.classList.add("hidden");
          this.serverErrorEl.classList.add("hidden");
        }

        if (shopifyServerError) {
          this.serverErrorEl.classList.remove("hidden");
          // hide others
          this.searchErrorEl.classList.add("hidden");
          this.contentBoxEl.classList.add("hidden");
        }

        if (notFound) {
          this.searchErrorEl.classList.remove("hidden");
          // hide others
          this.serverErrorEl.classList.add("hidden");
          this.contentBoxEl.classList.add("hidden");
        }
        // remove loading
        this.classList.remove("loading");
      }
    },
  );
}

// when variant changes update the data variant attr on main product section.
// this is added so that accordion can be rendred dynamically based on variant.
document.addEventListener("product:variant-change", function (evt) {
  const allProductIdAttributesEl = document.querySelectorAll(
    "[data-current-product-id]",
  );

  if (allProductIdAttributesEl.length > 0) {
    allProductIdAttributesEl.forEach((el) => {
      el.setAttribute("data-current-product-id", evt.detail.variant.id);
    });
  }
});

// when variant changes, update the variant-name subtitle shown under the product title
document.addEventListener("product:variant-change", function (evt) {
  const variant = evt.detail.variant;
  document.querySelectorAll("[data-variant-title]").forEach((el) => {
    el.textContent = variant ? variant.title : "";
  });
});

(function () {
  var root = document.querySelector("[data-scent-select]");
  if (!root) return;
  var bar = root.closest(".sticky-atc-bar");
  if (!bar) return;

  var optionIndex = parseInt(bar.getAttribute("data-scent-option-index") || "0", 10);
  var trigger = root.querySelector("[data-scent-trigger]");
  var triggerName = root.querySelector("[data-scent-trigger-name]");
  var triggerSw = root.querySelector("[data-scent-trigger-sw]");
  var tpl = root.querySelector("[data-scent-options-template]");
  if (!tpl || !trigger || !triggerName) return;

  var pop = document.createElement("div");
  pop.className = "scent-select-pop";
  pop.setAttribute("role", "listbox");
  var eyebrow = document.createElement("div");
  eyebrow.className = "scent-select-pop__eyebrow";
  eyebrow.textContent = "Aroma";
  pop.appendChild(eyebrow);
  pop.appendChild(tpl.content.cloneNode(true));
  document.body.appendChild(pop);

  root.hidden = false;

  var options = Array.prototype.slice.call(pop.querySelectorAll("[data-scent-option]"));

  function setOpen(open) {
    root.classList.toggle("is-open", open);
    pop.classList.toggle("is-open", open);
    trigger.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) position();
  }
  function isOpen() { return root.classList.contains("is-open"); }

  function position() {
    var r = trigger.getBoundingClientRect();
    pop.style.left = Math.max(8, r.left) + "px";
    pop.style.bottom = (window.innerHeight - r.top + 8) + "px";
  }

  // Build an attribute-selector-safe string from an option value.
  // Aroma values can contain "&", "(", spaces, etc.; escape backslashes and quotes.
  function attrEscape(value) {
    return String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  // Locate the matching desktop variant picker control for this scent value.
  // Prefer the swatch/chip button (theme.js wires clicks on [data-button] inside
  // [data-product-option] to its full variant-change pipeline). Fall back to the
  // hidden <select> when the option is rendered as a dropdown instead.
  function selectByValue(value) {
    var safe = attrEscape(value);
    var optionSel = '[data-product-option="option' + (optionIndex + 1) + '"]';

    var btn = document.querySelector(
      optionSel + ' [data-button][data-option-value="' + safe + '"]'
    );
    if (btn) {
      btn.click();
      return;
    }

    var select = document.querySelector(
      '[data-index="option' + (optionIndex + 1) + '"] select[name^="options"]'
    );
    if (select) {
      select.value = value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function syncUiToValue(value) {
    var matchedColor = "";
    options.forEach(function (opt) {
      var match = opt.getAttribute("data-scent-value") === value;
      opt.classList.toggle("is-selected", match);
      if (match) matchedColor = opt.getAttribute("data-scent-color") || "";
    });
    triggerName.textContent = value;
    if (triggerSw) triggerSw.style.backgroundColor = matchedColor;
  }

  options.forEach(function (opt) {
    opt.addEventListener("click", function () {
      var value = opt.getAttribute("data-scent-value");
      selectByValue(value);
      syncUiToValue(value);
      setOpen(false);
    });
  });

  trigger.addEventListener("click", function (e) {
    e.stopPropagation();
    setOpen(!isOpen());
  });

  document.addEventListener("click", function (e) {
    if (!root.contains(e.target) && !pop.contains(e.target)) setOpen(false);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setOpen(false);
  });
  window.addEventListener("scroll", function () { if (isOpen()) position(); }, true);
  window.addEventListener("resize", function () { if (isOpen()) position(); });

  document.addEventListener("product:variant-change", function (evt) {
    var v = evt.detail && evt.detail.variant;
    if (!v || !v.options) return;
    syncUiToValue(v.options[optionIndex]);
  });

  syncUiToValue(triggerName.textContent.trim());
})();

/* Quiz-result PDP anchor scroll pin.
   Two things fight the browser's hash-load scroll to #offer:
     1. theme.js's variant-init calls scrollIntoView on the product image
        with block:"nearest" — if it runs after the browser's scroll, it
        snaps the page back to the top.
     2. Lazy-loaded blocks above the anchor push it out of view later.
   Fix: pin to #offer once *after* window.load (so the variant-init scroll
   has already happened), then re-pin if document height shifts again.
   Bails the moment the user touches the scroll. */
(function () {
  var body = document.body;
  if (!body) return;
  var suffix = body.getAttribute("data-template-suffix") || "";
  if (suffix.indexOf("quiz-result-") !== 0) return;
  if (window.location.hash !== "#offer") return;

  var target = document.getElementById("offer");
  if (!target) return;

  var userInteracted = false;
  function onUserScroll() { userInteracted = true; }
  window.addEventListener("wheel", onUserScroll, { passive: true, once: true });
  window.addEventListener("touchstart", onUserScroll, { passive: true, once: true });
  window.addEventListener("keydown", onUserScroll, { once: true });

  function pin() {
    if (userInteracted) return;
    target.scrollIntoView({ behavior: "instant", block: "start" });
  }

  function pinAfterLoad() { setTimeout(pin, 100); }
  if (document.readyState === "complete") {
    pinAfterLoad();
  } else {
    window.addEventListener("load", pinAfterLoad, { once: true });
  }

  var lastHeight = document.documentElement.scrollHeight;
  var stableTimer = null;
  var hardStop = null;
  var ro = null;
  function cleanup() {
    window.removeEventListener("resize", onResize);
    if (ro) ro.disconnect();
    clearTimeout(stableTimer);
    clearTimeout(hardStop);
  }
  function onResize() {
    var h = document.documentElement.scrollHeight;
    if (h === lastHeight) return;
    lastHeight = h;
    clearTimeout(stableTimer);
    stableTimer = setTimeout(function () { pin(); cleanup(); }, 250);
  }
  window.addEventListener("resize", onResize);
  if ("ResizeObserver" in window) {
    ro = new ResizeObserver(onResize);
    ro.observe(document.body);
  }
  hardStop = setTimeout(cleanup, 5000);
})();
